import { TGetNewbuildingDeveloperValuationResponse_1 } from '../../repositories/newbuilding-estimate/v1/get-newbuilding-developer-valuation';
import { IDeveloperValuationState } from '../../types/developerValuation/developerValuationState';

export type TDeveloperValuationPreparedData = Partial<IDeveloperValuationState>;

export const prepareDeveloperValuationState = (
  res: TGetNewbuildingDeveloperValuationResponse_1 | null,
): TDeveloperValuationPreparedData | null => {
  if (!res) {
    return null;
  }

  return {
    pricesFiltersState: {
      buildingClass: res.filters.activeBuildingClass,
      period: res.filters.activePeriod,
      roomCount: res.filters.activeRoomCount,
      regionId: res.filters.activeRegionId,
    },
    developerValuation: {
      chart: res.chart,
      filters: res.filters,
      priceDynamics: res.priceDynamics,
    },
  };
};
